import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export abstract class AxiosHttpClient {
  protected readonly instance: AxiosInstance;
  protected token: string = '';

  constructor(baseURL: string) {
    this.instance = axios.create({
      baseURL,
    });

    this.initializeRequestInterceptor();
    this.initializeResponseInterceptor();
  }

  public setAuthToken(token: string) {
    this.token = token;
    this.instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  protected handleRequest = (config: AxiosRequestConfig) => {
    return config;
  };

  protected handleResponse = (res: AxiosResponse) => res;

  protected handleError = (error: any) => Promise.reject(error);

  private initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this.handleRequest, this.handleError);
  };

  private initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use(this.handleResponse, this.handleError);
  };
}
